export default __webpack_public_path__ + "static/media/CrudeFigure3.55713293.jpeg";